import * as React from 'react';
import { z } from 'zod';

import { Res } from 'core/api';
import { Result } from 'core/infrastructure';
import { PosScreen, Header, Content, LargeDeviceOnly, Footer, PhoneOnly, BackActionButton, Filler, AcceptActionButton } from 'pos/ui';
import { VStack, Text, Box } from '@chakra-ui/react';
import { Modal } from 'core/ui-next/modal';
import { FormRef, useControlsFor } from 'core/ui-next/controls';
import { BasicButton, SvgIcon } from 'core/ui-next';
import * as CoreImages from 'core/img';
import * as UI from 'core/ui';

type Props = Modal.Actions<string>;

const passwordSchema = z.object({
	password: z.string().nonempty(Res.Msg.MSG_REQUIRED_PASSWORD())
});

type PasswordValue = z.infer<typeof passwordSchema>;

function GetPassword(props: Props) {

	const { cancel, close } = props;
	const { Form, PasswordInput } = useControlsFor<PasswordValue>();

	const formRef = React.useRef<FormRef<PasswordValue>>(null);

	const onCancel = React.useCallback(async () => cancel(), [cancel]);
	const onAccept = React.useCallback(async () => {
		const result = await formRef.current!.getValue();
		if (!result.ok)
			return;

		close(result.value.password);
	}, [close]);

	return <PosScreen screenId='GET_RESELLER_PASSWORD' size={'small'} useKeyPad={true}>
		<Header title={Res.Web.GET_RESELLER()} onClose={onCancel} />

		<Content>
			<Box paddingX='6' paddingY='4' height={'full'} alignContent={'center'}>
				<Box w='full' mb='6'>
					<SvgIcon margin={'auto'} src={CoreImages.Info} h='12' w='12' color='blue.500' />
				</Box>
				<Form initialValue={{ password: '' }} schema={passwordSchema} ref={formRef}>
					<VStack w='full' justifyContent={'center'} gap='6'>
						<Text textAlign={'center'} fontSize={'sm'}>{Res.Web.GET_RESELLER_PASSWORD_LBL()}</Text>
						<PasswordInput linkTo={'password'} placeholder={Res.Msg.MSG_INTRODUCE_YOUR_PASSWORD_LBL()} onKeyDown={UI.whenEnterKey(onAccept)} autoComplete='on' />
					</VStack>
				</Form>
				<LargeDeviceOnly>
					<BasicButton type='success' text={Res.Common.OK_BTN()} onClick={onAccept} marginTop='6' />
				</LargeDeviceOnly>
			</Box>
		</Content>

		<Footer>
			<PhoneOnly>
				<BackActionButton action={onCancel} />
				<Filler />
				<AcceptActionButton action={onAccept} />
			</PhoneOnly>
		</Footer>

	</PosScreen>;
}


export default async function getResellerPassword(): Promise<Result<string>> {
	return await Modal.show(GetPassword);
}
